// extracted by mini-css-extract-plugin
module.exports = {"form_container":"sidebarFormStyles_form_container__2bxkR"};